import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useProject,
  useFind: useProjects,
  useCreate: useProjectCreation,
  useUpdate: useProjectUpdate,
} = getCRUDHooks({
  entityName: 'project',
  getHelper: () => clientApi.getOCClient().helpers.learningContent.projects,
});

export { useProject, useProjects, useProjectCreation, useProjectUpdate };
